const esAuth = {
  notProvisionedLogin: 'Esta cuenta no está autorizada. Pide a tu banquero o administrador que te registre primero.',
  needsLinkingLogin: 'Este correo ya está registrado con contraseña. Entra con tu contraseña abajo para vincular Google, o usa el enlace de invitación de tu banquero.',
  googleEmailMismatch: 'La cuenta de Google debe usar el mismo correo que registró tu banquero.',
  registerInviteTitle: 'Enlace de invitación listo',
  registerInviteHint: 'Comparte este enlace para que el usuario establezca una contraseña antes del primer acceso.',
  registerGmailHint: 'Correo Gmail: después de crear la contraseña, puede pulsar Continuar con Google en el login para vincular la misma cuenta.',
  registerInviteCopy: 'Copiar enlace',
  registerInviteShare: 'Compartir…',
  registerInviteWhatsApp: 'WhatsApp',
  registerInviteEmailSent: 'Correo de invitación enviado.',
  registerInviteEmailFailed: 'No se pudo enviar el correo. Comparte el enlace manualmente.',
  registerDone: 'Listo',
  userAlias: 'Alias',
  userAliasHint: 'Opcional. Se usa para saludar e identificar al usuario en toda la app.',
  compensationOptional: 'Ninguna (definir después)',
  compensationSectionHint: 'Opcional. Si eliges un tipo, el porcentaje o tarifa pasa a ser obligatorio.',
  compensationRequiredHint: 'Los términos de compensación son obligatorios para este rol.',
  compensationOptionalForBanker: 'Opcional para banqueros. Si eliges un tipo, el porcentaje o tarifa pasa a ser obligatorio.',
  compensationSelectRequired: 'Selecciona compensación…',
  registerProfileSection: 'Datos del perfil',
  registerRecommended: 'Recomendado',
  registerCapturePhoto: 'Tomar foto',
  registerUploadPhoto: 'Subir',
  registerClearPhoto: 'Quitar',
  registerChangePhoto: 'Cambiar foto',
  ciWizardTitle: 'Carnet de identidad (CI)',
  ciWizardStepOf: 'Paso {current} de {total}',
  ciWizardStepFront: 'Anverso del CI',
  ciWizardStepBack: 'Reverso del CI',
  ciWizardStepFrontShort: 'Anverso',
  ciWizardStepBackShort: 'Reverso',
  ciWizardReview: 'Revisión',
  ciWizardComplete: 'Completo',
  ciWizardGuideFront: 'Encaja el anverso del CI en el marco. Buena luz, sin brillos.',
  ciWizardGuideBack: 'Gira el carnet y captura el reverso igual.',
  ciWizardGuideReview: 'Ambos lados listos. Repite alguno si salió borroso.',
  ciWizardGuideLocked: 'Fotos del CI guardadas. Solo el administrador puede cambiarlas.',
  ciWizardRetake: 'Repetir',
  cameraUnavailable: 'No hay cámara disponible en este dispositivo.',
  userCiNumber: 'Número de CI',
  userCiNumberHint: '11 dígitos cuando esté disponible',
  userCiFront: 'Foto CI — anverso',
  userCiBack: 'Foto CI — reverso',
  profileCiAttachPhotos: 'Adjuntar fotos del CI',
  profileCiAttachFront: 'Adjuntar anverso del CI',
  profileCiAttachBack: 'Adjuntar reverso del CI',
  profileCiViewFront: 'Ver anverso del CI',
  profileCiViewBack: 'Ver reverso del CI',
  userProfilePhoto: 'Foto de perfil',
  userAddr: 'Dirección',
  userAddrHint: 'Para ubicarlo en rutas (calle, municipio)',
  registerUseHouseAddr: 'Usar dirección de la casa',
  profileUseHouseAddr: 'Usar la dirección de la casa matriz',
  userBio: 'Bio',
  userBioHint: 'Nota breve sobre la persona',
  userBankerNote: 'Nota interna',
  userBankerNoteHint: 'Solo visible para banquero / administrador',
  registerMediaUploadFailed: 'Usuario creado, pero una o más fotos no se pudieron subir.',
  authActionSetPasswordTitle: 'Define tu contraseña',
  authActionSetPasswordHint: 'Elige una contraseña segura para {email}.',
  authActionSetPasswordHintGeneric: 'Elige una contraseña segura para tu cuenta Alea TUI.',
  authActionConfirmPassword: 'Confirmar contraseña',
  authActionSavePassword: 'Guardar contraseña',
  authActionPasswordChanged: 'Contraseña actualizada',
  authActionPasswordChangedBody: 'Ya puedes iniciar sesión con tu nueva contraseña.',
  authActionGoLogin: 'Ir al login',
  authActionContinue: 'Continuar',
  showPassword: 'Mostrar contraseña',
  hidePassword: 'Ocultar contraseña',
  loginFailed: 'No se pudo iniciar sesión. Revisa usuario y contraseña e inténtalo de nuevo.',
  mfaInvalidCode: 'Código de verificación incorrecto. Prueba el código actual de tu app autenticadora.',
  mfaSessionExpired: 'La sesión de dos pasos expiró. Cancela, vuelve a entrar con tu contraseña y usa un código nuevo.',
  mfaRecoveryTitle: 'Recuperación de cuenta',
  mfaRecoveryHint: 'Demasiados códigos incorrectos del autenticador. Recupera con un código por correo, o pide a soporte que quite el MFA.',
  mfaRecoveryViaEmail: 'Recuperar por correo',
  mfaRecoveryAskSupport: 'Pedir a soporte',
  mfaRecoveryNoEmail: 'No hay un correo verificado para recuperar. Pide a soporte que quite el MFA de tu cuenta.',
  mfaRecoveryCodePrompt: 'Introduce el código de 6 dígitos que enviamos a {email}.',
  mfaRecoveryConfirm: 'Quitar MFA',
  mfaRecoveryCleared: 'Se quitó el MFA del autenticador. Vuelve a iniciar con tu contraseña y reactívalo en Ajustes.',
  mfaRecoverySignInAgain: 'Iniciar de nuevo',
  mfaRecoverySupportRequested: 'Se avisó a soporte. Quitarán el MFA tras verificar tu identidad.',
  mfaRecoverySendFailed: 'No se pudo enviar el código. Revisa tu contraseña o pide a soporte.',
  mfaRecoveryCodeInvalid: 'Código inválido o expirado. Inténtalo de nuevo o pide otro.',
  mfaRecoveryCooldown: 'Espera un minuto antes de pedir otro código.',
  loginAmbiguous: 'Hay más de una cuenta con ese usuario. Inicia sesión con el correo completo.',
  loginNetworkFailed: 'No se pudo completar el acceso. Revisa la conexión y vuelve a intentar. Si tienes Relé privado o VPN y sigue fallando, pruébalo un momento sin eso.',
  loginAppCheckFailed: 'No se pudo verificar este dispositivo. Revisa la conexión e inténtalo de nuevo.',
  loginRateLimited: 'Demasiados intentos de acceso. Espera unos minutos e inténtalo de nuevo.',
  loginGapiStatus: 'Ruta de red: {mode} · {origin}',
  loginGapiModeProxy: 'Proxy',
  loginGapiModeDirect: 'Directa',
  registerInviteMirrorHint: 'Enlace alterno (úsalo si alea-tui.com no abre — p. ej. desde Cuba sin VPN):',
  authActionWorkingTitle: 'Procesando…',
  authActionWorkingBody: 'Validando tu enlace seguro.',
  authActionEmailVerified: 'Correo verificado',
  authActionEmailVerifiedBody: 'Tu correo quedó confirmado. Ya puedes continuar en la app.',
  authActionEmailRestored: 'Correo restaurado',
  authActionEmailRestoredBody: 'El correo de tu cuenta se restauró a {email}.',
  authActionRecoverTitle: '¿Restaurar el correo anterior?',
  authActionRecoverBody: 'Esto deshará un cambio de correo no autorizado y restaurará {email}.',
  authActionRecoverBodyGeneric: 'Esto deshará un cambio de correo no autorizado en tu cuenta.',
  authActionRecoverConfirm: 'Restaurar correo',
  authActionRecoverFailed: 'No se pudo restaurar el correo. Pide un enlace nuevo.',
  authActionPasswordMismatch: 'Las contraseñas no coinciden.',
  authActionPasswordWeak: 'Elige una contraseña más fuerte.',
  authActionResetFailed: 'No se pudo actualizar la contraseña. Pide un enlace nuevo.',
  authActionInvalidLink: 'Este enlace de invitación o restablecimiento no es válido o ya expiró.',
  authActionInvalidTitle: 'Enlace no disponible',
  authActionUnsupportedTitle: 'Enlace no compatible',
  authActionUnsupportedBody: 'Abre este enlace desde un correo de Alea TUI, o ve al login.',
  passwordStrengthVeryWeak: 'Muy débil',
  passwordStrengthWeak: 'Débil',
  passwordStrengthFair: 'Aceptable',
  passwordStrengthGood: 'Buena',
  passwordStrengthStrong: 'Fuerte',
  passwordHintLength: 'Al menos 8 caracteres',
  passwordHintCase: 'Mayúsculas y minúsculas',
  passwordHintDigit: 'Al menos un número',
  passwordHintSymbol: 'Un símbolo ayuda (recomendado)',
  accessReqLink: 'Solicitar acceso a la plataforma',
  accessReqBack: 'Volver',
  accessReqBackToLogin: 'Volver al inicio de sesión',
  accessReqTitle: 'Solicitud de acceso',
  accessReqHint: 'Cuéntanos quién eres. El acceso es por invitación y lo revisa el equipo de la plataforma.',
  accessReqChecklistTitle: 'Qué esperar',
  accessReqCheckInvite: 'Las cuentas se crean por invitación: este formulario no abre la app por sí solo.',
  accessReqCheckReferral: 'Se exige un código de referido válido de un miembro; los códigos inválidos se rechazan.',
  accessReqCheckRoles: 'Entras a una casa como banquero o personal (listador / recogedor), con roles y cierres.',
  accessReqCheckIdentity: 'Necesitamos contacto real; tras la invitación puede aplicar confianza de dispositivo.',
  accessReqCheckResults: 'Los resultados siguen sorteos oficiales de Florida / Nueva York (bolita Miami).',
  accessReqCheckReview: 'La revisión puede demorar; te enviamos un correo al recibir la solicitud.',
  accessReqReferral: 'Código de referido',
  accessReqReferralHint: 'Código de quien te refirió',
  accessReqReferralFromLink: 'Cargado desde tu enlace de invitación — puedes editarlo si hace falta.',
  accessReqName: 'Nombre completo',
  accessReqEmail: 'Correo',
  accessReqPhone: 'Teléfono / WhatsApp',
  accessReqPhoneHint: '+53 …',
  accessReqCity: 'Ciudad / municipio',
  accessReqIntent: '¿Qué necesitas?',
  accessReqIntentPlaceholder: 'Selecciona…',
  accessReqIntentOpen: 'Abrir o gestionar una casa',
  accessReqIntentJoin: 'Unirme a una casa como personal',
  accessReqIntentOther: 'Otra cosa',
  accessReqOrg: 'Casa o grupo (opcional)',
  accessReqOrgHint: 'Nombre si ya tienes uno',
  accessReqMessage: 'Mensaje',
  accessReqMessageHint: 'Un poco de contexto ayuda a enrutar tu pedido',
  accessReqAck: 'Leí la lista y entiendo que el acceso es por invitación tras revisión.',
  accessReqSubmit: 'Enviar solicitud',
  accessReqSubmitting: 'Enviando…',
  accessReqSuccessTitle: 'Solicitud recibida',
  accessReqSuccessBody: 'Te contactaremos si podemos avanzar. Revisa tu correo para la confirmación.',
  accessReqErrName: 'Escribe tu nombre.',
  accessReqErrEmail: 'Escribe un correo válido.',
  accessReqErrPhone: 'Escribe un teléfono o WhatsApp.',
  accessReqErrCity: 'Escribe tu ciudad.',
  accessReqErrIntent: 'Selecciona qué necesitas.',
  accessReqErrAck: 'Confirma que leíste la lista.',
  accessReqErrReferral: 'Escribe el código de quien te refirió.',
  accessReqErrReferralInvalid: 'Ese código de referido no es válido.',
  accessReqErrReferralSelf: 'No puedes usar tu propio código de referido.',
  accessReqErrRate: 'Ya enviaste una solicitud recientemente. Inténtalo mañana.',
  accessReqErrGeneric: 'No se pudo enviar. Inténtalo más tarde.',
  profileReferralCode: 'Tu código de referido',
  profileReferralCopy: 'Copiar código',
  profileReferralCopyLink: 'Copiar enlace',
  profileReferralShare: 'Compartir invitación',
  profileReferralHelp: 'Ayuda sobre referidos',
  profileReferralHint: 'Comparte tu enlace de invitación para que abran el formulario de acceso con tu código ya relleno. Ganas comisión cuando se les provisiona la cuenta.',
  profileReferralStats: '{count} referidos · {amount} CUP acumulados',
  profileReferralShareText: 'Solicita acceso a Alea TUI con mi código de referido:',
  profileUsername: 'Nombre de usuario',
  profileUsernameEdit: 'Editar usuario',
  profileUsernameSave: 'Guardar usuario',
  profileUsernameHint: 'Así entras a la app (sin el dominio del correo).',
  profileUsernameChecking: 'Comprobando disponibilidad…',
  profileUsernameAvailable: 'Disponible.',
  profileUsernameTaken: 'Ese nombre de usuario ya está en uso.',
  profileUsernameInvalid: 'Usa 3–32 caracteres: letras, números, punto, guion o guion bajo.',
  profileAliasAdd: 'Definir alias',
  profileAliasRemove: 'Quitar alias',
  profileEmailEdit: 'Cambiar correo',
  profileEmailHint: 'Correo de la cuenta. Te enviaremos un código al nuevo buzón para confirmarlo.',
  profileAltEmail: 'Correo alternativo',
  profileAltEmailAdd: 'Añadir correo alternativo',
  profileAltEmailRemove: 'Quitar',
  profileAltEmailHint: 'Opcional. También requiere confirmación por código.',
  profilePhone: 'Teléfono',
  profilePhoneAdd: 'Añadir teléfono',
  profilePhoneRemove: 'Quitar',
  profilePhoneHint: 'Opcional. Te enviaremos un SMS para confirmarlo.',
  profileContactSendCode: 'Enviar código',
  profileContactConfirm: 'Confirmar código',
  profileContactCodeHint: 'Introduce el código de 6 dígitos que recibiste.',
  profileContactCodeInvalid: 'Código inválido. Usa 6 dígitos.',
  profileContactVerified: 'Verificado',
  profileContactCooldown: 'Ya se envió un código. Espera un minuto antes de pedir otro.',
  profileContactUnchanged: 'Ese contacto ya está guardado.',
  profileContactReauthPrompt: 'Introduce tu contraseña para confirmar este cambio de teléfono.',
  staffReferralCode: 'Código de referido',
  staffReferralMissing: 'Sin código',
  staffReferralMint: 'Crear código',
  staffReferralMinted: 'Código de referido listo',
  staffReferralMintFailed: 'No se pudo crear el código de referido.',
  staffReferralHint: 'Comparte el enlace de invitación para que abran el formulario con este código ya relleno. Ganas comisión cuando se les provisiona.',
  staffReferralMissingHint: 'Esta cuenta aún no tiene código. Créalo para que pueda invitar a otros.',
  staffReferralOpsTitle: 'Códigos de referido',
  staffReferralOpsHint: '{missing} usuarios sin código. Abre Editar para crear uno, o genera todos.',
  staffReferralBackfill: 'Crear códigos faltantes',
  staffReferralBackfillConfirm: '¿Crear códigos de referido para usuarios que aún no tienen?',
  staffReferralBackfillOk: 'Backfill de referidos listo',
  staffReferralBackfillBody: 'Creados {minted} · ya tenían {skipped} · revisados {scanned}',
};

export default esAuth;
